export default __webpack_public_path__ + "static/media/Relic of Fallen Stars.177cf290.jpg";